import { CSS } from '../../../../theme/stitches.config';
import { SMPIcon, StyledIconVariants } from '../SMPIcon';

type SMPStandingsWinOverTimeIconProps = StyledIconVariants & {
  onClick?: () => void;
  css?: CSS;
};

export const SMPStandingsWinOverTimeIcon = (props: SMPStandingsWinOverTimeIconProps): JSX.Element => {
  return (
    <SMPIcon {...props}>
      <image
        width='20'
        height='20'
        xlinkHref='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iIzAwODIyRiIvPgo8cGF0aCBkPSJNMTMuMDk5NiAxNUgxMi4xMTUyTDEwLjM4NjcgOS4yNjM2N0MxMC4zMDQ3IDkuMDA5NzcgMTAuMjEyOSA4LjY4OTQ1IDEwLjExMTMgOC4zMDI3M0MxMC4wMDk4IDcuOTE2MDIgOS45NTcwMyA3LjY4MzU5IDkuOTUzMTIgNy42MDU0N0M5Ljg2NzE5IDguMTIxMDkgOS43MzA0NyA4LjY4NTU1IDkuNTQyOTcgOS4yOTg4M0w3Ljg2NzE5IDE1SDYuODgyODFMNC42MDM1MiA2LjQzMzU5SDUuNjU4Mkw3LjAxMTcyIDExLjcyNDZDNy4xOTkyMiAxMi40NjY4IDcuMzM1OTQgMTMuMTM4NyA3LjQyMTg4IDEzLjc0MDJDNy41MjczNCAxMy4wMjU0IDcuNjgzNTkgMTIuMzI2MiA3Ljg5MDYyIDExLjY0MjZMOS40MjU3OCA2LjQzMzU5SDEwLjQ4MDVMMTIuMDkxOCAxMS42ODk1QzEyLjI3OTMgMTIuMjk0OSAxMi40Mzc1IDEyLjk3ODUgMTIuNTY2NCAxMy43NDAyQzEyLjY0MDYgMTMuMTg1NSAxMi43ODEyIDEyLjUwOTggMTIuOTg4MyAxMS43MTI5TDE0LjMzNTkgNi40MzM1OUgxNS4zOTA2TDEzLjA5OTYgMTVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTUgMTVMMjAgMTBWMTZDMjAgMTguMjA5MSAxOC4yMDkxIDIwIDE2IDIwSDEwTDE1IDE1WiIgZmlsbD0iI0ZGRDgwMCIvPgo8L3N2Zz4K'
      />
    </SMPIcon>
  );
};
